import React from 'react';
import { connect } from 'react-redux';
import { Form } from 'react-bootstrap-5';

import { setFilterAttribute } from 'bundles/connect/components/store/actions/criteria';
import type { Criteria } from 'bundles/connect/types';

type MultiSelectInputProps = {
  criteria: Criteria;
  criteriaKey: string;
  disabled?: boolean;
  options: { [key: string]: string } | Map<string, string> | Map<number, string>;
  setFilterAttribute: (attribute: string, value: string | number, opts: { array: boolean }) => void;
}

function MultiSelectInput(
  { criteria, criteriaKey, disabled = false, options, setFilterAttribute }: MultiSelectInputProps
) {
  const selectedOptions = criteria[criteriaKey] || [];

  return (
    <div>
      {(options instanceof Map ? [...options.entries()] : Object.entries(options)).map(([key, value], idx) => (
        <Form.Check
          checked={selectedOptions.includes(key) || false}
          disabled={disabled}
          id={`${criteriaKey}_${idx}`}
          key={key}
          label={value}
          type="checkbox"
          onChange={() => setFilterAttribute(criteriaKey, key, { array: true })}
        />
      ))}
    </div>
  );
}

const mapStateToProps = ({ criteria }) => ({ criteria });

export default connect(mapStateToProps, { setFilterAttribute })(MultiSelectInput);
